import { useContext, useEffect, useState } from 'react';

import {
  Col,
  Dropdown,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import DashboardContext from '../../../Context';

import ModalDelete from '../ModalDelete';
import ModalCancel from './ModalCancel';
import ModalConfrim from './ModalConfrim';
import ModalCreateworker from './ModalCreateworker';
import ModalEditB2BWorker from './ModalEditB2BWorker';
import ModalJobDispatchWorker from './ModalJobDispatchWorker';
import ModalCustomSms from './ModalCustomSms';
import ModalDebtTracking from './ModalDebtTracking';
import ModalDetial from './ModalDetial';
import ModalJobSituation from './ModalJobSituation';
import ModalOrderCommisson from './ModalOrderCommisson';
import ModalOrderTracking from './ModalOrderTracking';
import ModalUpdateSurvey from './ModalUpdateSurvey';
import axios from 'axios';
import { toast } from 'react-toastify';
import ModalRollback from './ModalRollback';

export default function Tabelrowbody({
  item,
  number,
  handeldeleteitem,
  page,
  arryheder,
  urldata,
  arryactions,
  handelPrint,
  handelSms,
  handlestartwork,
  handeluser,
  hiddenitem,
  tipLink,
  refreshGridWorker,
}) {
  const {
    accessPage,
    handelEdit,
    handelAdd,
    handelIdview,
    handelloding,
    handeldmicro,
    handelidshowitem,
    handelEditOrder,
    authentication,
    urldashboard,
  } = useContext(DashboardContext);

  const survey = () => {
    if (Object.hasOwn(item, 'survey')) return true;
    return false;
  };

  const { location } = useHistory();

  const [keyarry, setKeyarry] = useState([]);

  const [moreitem, setMoreitem] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const handeldelete = () => {
    handeldeleteitem();
    handleClose();
  };

  const [showBoxacces, setshowBoxacces] = useState(false);
  const renderTooltip = (props) => (
    <Tooltip id='button-tooltip' {...props}>
      سفارش از طریق crm ثبت شده و قابل خواندن نیست
    </Tooltip>
  );
  const togglereadcanceledbycallcentre = async (data, e) => {
    const res =
      data?.appType !== 0
        ? await axios.post(
            urldashboard +
              '/businesstobusinesscanceledorder/togglereadcanceledbycallcentre',
            {
              orderScheduleId: data.id,
              readCanceledByCallCentre: e.target.checked,
            },
            {
              headers: {
                Authorization: authentication,
                'Content-Type': 'application/json',
              },
            },
          )
        : { data: { message: {} } };
    data?.appType !== 0
      ? toast.success(res?.data?.message, {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      : toast.warning('سفارش از طریق crm ثبت شده و قابل خواندن نیست', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  };

  useEffect(() => {
    setshowBoxacces(
      arryactions
        ? arryactions.length > 1
          ? true
          : false
        : accessPage
          ? accessPage.length > 1
            ? true
            : false
          : false,
    );

    if (item) {
      let mytd = [];
      for (const property in item) {
        if (item[property] === item.id) {
        } else {
          mytd.push(item[property]);
        }
      }
      setKeyarry(mytd);
    }
    return () => {};
  }, [item]);

  const handleEditbtn = (id) => {
    handelAdd(true);
    if (urldata) {
      handelEditOrder(true);
    } else {
      handelAdd(true);
    }
    handelEdit(id);
    handelloding(true);
  };

  const handelview = (id) => {
    handelIdview(id);
    handelloding(true);
  };
  const handelshowWork = (id) => {
    if (urldata) {
      handeldmicro(true);
    } else {
      handelAdd(true);
    }
    handelidshowitem(id);
    handelloding(true);
  };

  const handelCopy = (name) => {
    navigator.clipboard.writeText(name);
  };

  //ModalOrderTracking

  const [showModalOrderTracking, setShowModalOrderTracking] = useState(false);

  const handeltracking = () => setShowModalOrderTracking(true);

  const handelcloseOrderTracking = () => setShowModalOrderTracking(false);

  //modal createworker

  const [Showcreateworker, setShowcreateworker] = useState(false);
  const [ShowEditB2BWorker, setShowEditB2BWorker] = useState(false);

  const [ShowModalJobDispatchWorker, setShowModalJobDispatchWorker] =
    useState(false);

  const handelcreateworker = () => setShowcreateworker(true);
  const handelEditB2BWorker = () => setShowEditB2BWorker(true);

  const handelShowModalJobDispatchWorker = () =>
    setShowModalJobDispatchWorker(true);
  const handelHideModalJobDispatchWorker = () =>
    setShowModalJobDispatchWorker(false);

  const handelClosecreateworker = () => setShowcreateworker(false);
  const handelCloseEditB2BWorker = () => setShowEditB2BWorker(false);

  //ModalUpdateSurvey
  /**
   * app type enum
   * 0 CRM
   * 1 webSite
   * 2 Android App
   * 3 IOS App
   * 4 WEB APP
   */

  const [showModalUpdateSurvey, setShowModalUpdateSurvey] = useState(false);

  const handleCloseModalUpdateSurvey = () => setShowModalUpdateSurvey(false);

  const handelCreateSurvey = () => {
    setShowModalUpdateSurvey(true);
  };

  // modal Cancel
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [RollbackModal, setRollbackModal] = useState(false);

  const handelCancel = () => setShowModalCancel(true);
  const handelCloseCancel = () => setShowModalCancel(false);

  const handleRollback = () => setRollbackModal(true);
  const handelCloseRollback = () => setRollbackModal(false);

  //Modal Confirm
  const [showConfrim, setShowConfrim] = useState(false);
  const handelConfirm = () => setShowConfrim(true);
  const handelCloseConfirm = () => setShowConfrim(false);

  //ModalDebtTracking

  const [showModalTracking, setShowModalTracking] = useState(false);

  const handelDebtTracking = () => setShowModalTracking(true);

  const closeDebtTracking = () => setShowModalTracking(false);

  //DetialModal

  const [showModalDetial, setShowModalDetial] = useState(false);

  const closeModalDetial = () => setShowModalDetial(false);

  //OrderCommission

  const [showOrderCommission, setShowOrderCommission] = useState(false);

  const handelOrderCommission = () => setShowOrderCommission(true);

  const closeMdalOrderCommission = () => setShowOrderCommission(false);

  const handleRefreshGridWorker = () => {
    refreshGridWorker();
  };
  /**job situation */

  const [jobsituation, setJobsituation] = useState(false);

  const handelShowModaljobsituation = () => setJobsituation(true);
  const handelCloseModaljobsituation = () => setJobsituation(false);

  /**modal custom SMS  */
  const [customSms, setCustomSms] = useState(false);
  const handelShowModalCustomSms = () => setCustomSms(true);
  const handelCloseModalCustomSms = () => setCustomSms(false);

  // eslint-disable-next-line no-unused-vars
  const getBackgroundColor = (
    isFavorite,
    orderTypeName,
    jobDispatchRemainingTimeStatus,
  ) => {
    if (isFavorite) return 'rgb(254 255 188)';
    //orange
    if (orderTypeName === 'ثبت موقت') return 'rgb(255 157 74)';
    //grren
    if (jobDispatchRemainingTimeStatus === 0) return '	rgb(0,251,100)';
    //yellow
    if (jobDispatchRemainingTimeStatus === 2) return '	rgb(255,255,51)';
    //light red
    if (jobDispatchRemainingTimeStatus === 3) return '	rgb(255,204,204)';
    //red
    if (jobDispatchRemainingTimeStatus === 4) return '	rgb(255,74,74)';
  };

  return (
    <>
      <tr
        style={{
          backgroundColor: getBackgroundColor(
            item.isFavorite,
            item.orderTypeName,
            item.jobDispatchRemainingTimeStatus,
          ),
        }}
      >
        <td className='morerow' style={moreitem ? { width: '300px' } : {}}>
          {Object.keys(item).length > 0 ? (
            Object.keys(item).length > 10 ? (
              <span onClick={() => setMoreitem(!moreitem)} className='ml-2'>
                {moreitem ? (
                  <i className='mdi mdi-arrow-up-bold-circle'></i>
                ) : (
                  <i className='mdi mdi-arrow-down-bold-circle'></i>
                )}
              </span>
            ) : null
          ) : null}
          {showBoxacces ? (
            <Dropdown>
              <Dropdown.Toggle
                variant='success'
                id={item?.id?.toString()}
                disabled={item?.type === 6 || item?.type === 7}
              >
                <i className='mdi icon-sm mdi-table-edit'></i>
              </Dropdown.Toggle>
              {/* <button>ثبت کار</button> */}
              <Dropdown.Menu alignRight style={{ zIndex: '999' }}>
                {arryactions ? (
                  arryactions.includes('Detial') ? (
                    <Dropdown.Item
                      onClick={() => setShowModalDetial(true)}
                      style={{ color: 'green' }}
                    >
                      مشاهده جزئیات <i className='mdi mdi-eye'></i>
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Detial') ? (
                  <Dropdown.Item
                    onClick={() => setShowModalDetial(true)}
                    style={{ color: 'green' }}
                  >
                    مشاهده جزئیات <i className='mdi mdi-eye'></i>
                  </Dropdown.Item>
                ) : null}
                {}
                {arryactions ? (
                  arryactions.includes('Delete') ? (
                    <Dropdown.Item
                      onClick={handleShow}
                      style={{ color: 'green' }}
                    >
                      حذف <i className='mdi icon-sm mdi-delete'></i>
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Delete') ? (
                  <Dropdown.Item
                    onClick={handleShow}
                    style={{ color: 'green' }}
                  >
                    حذف <i className='mdi icon-sm mdi-delete'></i>
                  </Dropdown.Item>
                ) : null}

                {arryactions ? (
                  arryactions.includes('Update') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      onClick={() => handleEditbtn(item.id)}
                    >
                      ویرایش <i className='mdi mdi-pencil'></i>
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Update') ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={() => handleEditbtn(item.id)}
                  >
                    ویرایش <i className='mdi mdi-pencil'></i>
                  </Dropdown.Item>
                ) : null}
                {urldata ? null : accessPage.includes('Profile') ? (
                  <Dropdown.Item
                    style={{ color: 'blue' }}
                    onClick={() => handelview(item.id)}
                  >
                    مشاهده <i className='mdi mdi-eye'></i>
                  </Dropdown.Item>
                ) : null}
                {location.pathname === '/WorkerOrderSchedule' ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelDebtTracking}
                  >
                    پیگیری مالی
                  </Dropdown.Item>
                ) : urldata === '/WorkerOrderSchedule' ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelDebtTracking}
                  >
                    پیگیری مالی
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('Confirm') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      onClick={handelConfirm}
                    >
                      تایید کار
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Confirm') ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelConfirm}
                  >
                    تایید کار
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('UpdateType') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      // onClick={() => handelshowWork(item.id)}
                      onClick={handelShowModaljobsituation}
                    >
                      وضعیت کار
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('UpdateType') ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelShowModaljobsituation}
                    // onClick={() => handelshowWork(item.id)}
                  >
                    وضعیت کار
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('CreateWorker') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      onClick={handelcreateworker}
                    >
                      انتخاب نیرو
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('CreateWorker') ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelcreateworker}
                  >
                    انتخاب نیرو
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('SendWorkerSmsWithMessage') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      onClick={handelShowModalCustomSms}
                    >
                      ارسال پیام دلخواه
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('SendWorkerSmsWithMessage') ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelShowModalCustomSms}
                  >
                    ارسال پیام دلخواه
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('GetOrderTracking') ? (
                    <Dropdown.Item
                      style={{ color: 'blue' }}
                      onClick={handeltracking}
                    >
                      پیگیری کننده ها
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('GetOrderTracking') ? (
                  <Dropdown.Item
                    style={{ color: 'blue' }}
                    onClick={handeltracking}
                  >
                    پیگیری کننده ها
                  </Dropdown.Item>
                ) : null}
                {survey() && (
                  <Dropdown.Item
                    style={{ color: 'blue' }}
                    onClick={handelCreateSurvey}
                  >
                    ثبت نظر
                  </Dropdown.Item>
                )}
                {item.hasOrderCommission ? (
                  <Dropdown.Item
                    style={{ color: 'blue' }}
                    onClick={handelOrderCommission}
                  >
                    پرداخت پورسانت
                  </Dropdown.Item>
                ) : null}
                {arryactions ? (
                  arryactions.includes('Cancel') ? (
                    <Dropdown.Item
                      style={{ color: 'red' }}
                      onClick={handelCancel}
                    >
                      لغو سفارش
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Cancel') ? (
                  <Dropdown.Item
                    style={{ color: 'red' }}
                    onClick={handelCancel}
                  >
                    لغو سفارش
                  </Dropdown.Item>
                ) : null}

                {item.profileBusinessType ? (
                  arryactions ? (
                    arryactions.includes('Cancel') ? (
                      <Dropdown.Item
                        style={{ color: 'green' }}
                        onClick={handelEditB2BWorker}
                      >
                        ویرایش ورود خروج و پایان کار
                      </Dropdown.Item>
                    ) : null
                  ) : accessPage.includes('Cancel') ? (
                    <Dropdown.Item
                      style={{ color: 'green' }}
                      onClick={handelEditB2BWorker}
                    >
                      ویرایش ورود خروج و پایان کار
                    </Dropdown.Item>
                  ) : null
                ) : null}
                {item?.orderStatusType === 5 && arryactions ? (
                  arryactions.includes('Rollback') ? (
                    <Dropdown.Item
                      style={{ color: 'orange' }}
                      onClick={handleRollback}
                    >
                      بازگشت از پایان کار
                    </Dropdown.Item>
                  ) : null
                ) : accessPage.includes('Rollback') &&
                  item?.orderStatusType === 5 ? (
                  <Dropdown.Item
                    style={{ color: 'orange' }}
                    onClick={handleRollback}
                  >
                    بازگشت از پایان کار
                  </Dropdown.Item>
                ) : null}
                {item.isAutoFindWorker ? (
                  <Dropdown.Item
                    style={{ color: 'green' }}
                    onClick={handelShowModalJobDispatchWorker}
                  >
                    وضعیت نیرو های انتخاب شده
                  </Dropdown.Item>
                ) : null}
              </Dropdown.Menu>
            </Dropdown>
          ) : null}
        </td>

        <td>{number + 1}</td>
        {hiddenitem ? null : location.pathname === '/WorkerOrderSchedule' ? (
          <>
            <td style={{ paddingBottom: '3%', position: 'relative' }}>
              <input
                type='checkbox'
                value={item.id}
                onChange={handlestartwork}
                id={`startwork-${item.id}`}
                className='form-check-input startworkCheckbox'
              />
            </td>
          </>
        ) : urldata === '/WorkerOrderSchedule' ? null : (
          <>
            <td style={{ paddingBottom: '3%', position: 'relative' }}>
              <input
                type='checkbox'
                value={item.id}
                onChange={handelPrint}
                id={`print-${item.id}`}
                className='form-check-input printCheckbox'
              />
            </td>
            <td style={{ paddingBottom: '3%', position: 'relative' }}>
              {urldata === '/BusinessToBusinessOrder' ? (
                <input
                  type='checkbox'
                  value={item.id}
                  onChange={handelSms}
                  id={`sms-${item.id}`}
                  className='form-check-input smscheckbox'
                  disabled
                />
              ) : (
                <input
                  type='checkbox'
                  value={item.id}
                  onChange={handelSms}
                  id={`sms-${item.id}`}
                  className='form-check-input smscheckbox'
                />
              )}
            </td>
            <td style={{ paddingBottom: '3%', position: 'relative' }}>
              <input
                type='checkbox'
                value={item.id}
                onChange={handeluser}
                id={`user-${item.id}`}
                className='form-check-input userCheckbox'
              />
            </td>
          </>
        )}
        {location.pathname === '/BusinessToBusinessCanceledOrder' ? (
          item?.appType === 0 ? (
            <OverlayTrigger
              placement='top'
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
              style={{ cursor: 'not-allowed' }}
              open
              zIndex={100000000}
            >
              {/* <Form.Check  
        style={{margin: '0 42%',cursor:'not-allowed',opacity:item?.appType!==5?'.3':undefined}}
        type="checkbox"
        // style={{paddingRight: '40%'}}
        name="hasAccessToDocuments"
        onChange={(e)=>togglereadcanceledbycallcentre(item,e)}
        // handelValue={handelValue}
        defaultChecked={item?.readCanceledByCallCentre}
        // label="مشاهده"
        // disabled={item?.appType!==5}
       /> */}
              <td>
                {' '}
                <svg
                  style={{
                    margin: '0 40%',
                    opacity: '.8',
                    cursor: 'not-allowed',
                  }}
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='#000'
                  class='bi bi-app'
                  viewBox='0 0 16 16'
                >
                  <path d='M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z' />
                </svg>
              </td>
            </OverlayTrigger>
          ) : (
            <td>
              <Form.Check
                type='checkbox'
                style={{ paddingRight: '40%' }}
                name='hasAccessToDocuments'
                onChange={(e) => togglereadcanceledbycallcentre(item, e)}
                // handelValue={handelValue}
                defaultChecked={item?.readCanceledByCallCentre}
                // label="مشاهده"
                // disabled={item?.appType!==5}
              />
            </td>
          )
        ) : null}
        {location.pathname === '/WorkerOrderSchedule' ? (
          <td>
            <Link to={`/Customer/${keyarry[0]}`} target='_blank'>
              {keyarry[1]}
            </Link>
          </td>
        ) : urldata === '/WorkerOrderSchedule' ? (
          <td>
            <Link to={`/Customer/${keyarry.slice(0, 4)[0]}`} target='_blank'>
              {keyarry.slice(0, 2)[1]}
            </Link>
          </td>
        ) : location.pathname === '/PeriodOrder' ? (
          <td>
            <Link to={`/Customer/${keyarry.slice(0, 3)[0]}`} target='_blank'>
              {keyarry.slice(0, 2)[1]}
            </Link>
          </td>
        ) : urldata === '/PeriodOrder' ? (
          <td>
            <Link to={`/Customer/${keyarry.slice(0, 3)[0]}`} target='_blank'>
              {keyarry.slice(0, 2)[1]}
            </Link>
          </td>
        ) : (
          <td>
            <OverlayTrigger
              placement='left'
              overlay={
                <Tooltip id={keyarry.slice(0, 4)[0]}>
                  {keyarry.slice(0, 4)[2]}
                </Tooltip>
              }
            >
              {/* <Link to={`/Customer/${keyarry.slice(0, 4)[0]}`} target="_blank" >
                                            <i className="mdi mdi-bell-outline"
                                                style={{ color: keyarry.slice(0, 4)[1] }} ></i>
                                            {keyarry.slice(0, 4)[3]}
                                        </Link> */}
              <Link to={`/Customer/${keyarry.slice(0, 4)[0]}`}>
                <i
                  className='mdi mdi-bell-outline'
                  style={{ color: keyarry.slice(0, 4)[1] }}
                ></i>
                {keyarry.slice(0, 4)[3]}
              </Link>
            </OverlayTrigger>
          </td>
        )}

        {/* {
                    location.pathname === '/WorkerOrderSchedule' ?
                    keyarry.slice(0, 3).map((td, index) => (<div>td</div>)) : null
                } */}

        {keyarry.length > 0 ? (
          location.pathname === '/WorkerOrderSchedule' ? (
            keyarry.slice(2, 12).map((td, index) =>
              typeof td === 'boolean' ? (
                <td key={index}>
                  {td ? (
                    <i className='fa fa-check'></i>
                  ) : (
                    <i className='fa fa-times'></i>
                  )}
                </td>
              ) : Object.keys(item)[index + 3].search('Amount') > -1 ||
                Object.keys(item)[index + 3].search('amount') > -1 ? (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 16,
                  }).format(parseFloat(td))}
                </td>
              ) : (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {Object.keys(item)[index + 3].search('workerFullName') > -1 ||
                  Object.keys(item)[index + 3].search('workerFullName') > -1 ? (
                    <div>
                      {td}{' '}
                      {keyarry[24] ? (
                        <i
                          style={{ fontSize: 20, color: '#ff00e0' }}
                          class='fa fa-mobile'
                          aria-hidden='true'
                        ></i>
                      ) : null}
                    </div>
                  ) : (
                    td
                  )}
                </td>
              ),
            )
          ) : urldata === '/WorkerOrderSchedule' ? (
            <>
              {keyarry.slice(2, 12).map((td, index) =>
                typeof td === 'boolean' ? (
                  <td key={index}>
                    {td ? (
                      <i className='fa fa-check'></i>
                    ) : (
                      <i className='fa fa-times'></i>
                    )}
                  </td>
                ) : Object.keys(item)[index + 3].search('Amount') > -1 ||
                  Object.keys(item)[index + 3].search('amount') > -1 ? (
                  <td onClick={() => handelCopy(td)} key={index + 3}>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 16,
                    }).format(parseFloat(td))}
                  </td>
                ) : (
                  <td onClick={() => handelCopy(td)} key={index + 3}>
                    {td}
                  </td>
                ),
              )}
              <td>{item?.workerPresenterName ?? '-'}</td>
            </>
          ) : location.pathname === '/PeriodOrder' ? (
            keyarry.slice(2, 10).map((td, index) =>
              typeof td === 'boolean' ? (
                <td key={index}>
                  {td ? (
                    <i className='fa fa-check'></i>
                  ) : (
                    <i className='fa fa-times'></i>
                  )}
                </td>
              ) : Object.keys(item)[index + 3].search('Amount') > -1 ||
                Object.keys(item)[index + 3].search('amount') > -1 ? (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 16,
                  }).format(parseFloat(td))}
                </td>
              ) : (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {td}
                </td>
              ),
            )
          ) : urldata === '/PeriodOrder' ? (
            keyarry.slice(2, 10).map((td, index) =>
              typeof td === 'boolean' ? (
                <td key={index}>
                  {td ? (
                    <i className='fa fa-check'></i>
                  ) : (
                    <i className='fa fa-times'></i>
                  )}
                </td>
              ) : Object.keys(item)[index + 3].search('Amount') > -1 ||
                Object.keys(item)[index + 3].search('amount') > -1 ? (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 16,
                  }).format(parseFloat(td))}
                </td>
              ) : (
                <td onClick={() => handelCopy(td)} key={index + 3}>
                  {td}
                </td>
              ),
            )
          ) : (
            arryheder.slice(0, 8).map((td, index) =>
              td.name === 'workerOrderSchedules' ? (
                <td>
                  {item['workerOrderSchedules'].map((item, index) => (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <p key={index}>{`${index + 1} - ${item.firstName} ${
                        item.lastName
                      } ${item.periodTime}`}</p>
                      {item.isFavorite ? (
                        <i
                          style={{ color: 'green' }}
                          class='fa fa-star'
                          aria-hidden='true'
                        ></i>
                      ) : null}
                      {item.star !== 0 ? (
                        <p style={{ color: '#FF4500' }}>(امتیاز:{item.star})</p>
                      ) : null}
                    </div>
                  ))}
                </td>
              ) : typeof item[td.name] === 'boolean' ? (
                <td key={index}>
                  {item[td.name] ? (
                    <i className='fa fa-check'></i>
                  ) : (
                    <i className='fa fa-times'></i>
                  )}
                </td>
              ) : td.name.search('Amount') > -1 ||
                td.name.search('amount') > -1 ? (
                <td onClick={() => handelCopy(item[td.name])} key={index}>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 16,
                  }).format(parseFloat(item[td.name]))}
                </td>
              ) : (
                <td onClick={() => handelCopy(item[td.name])} key={index}>
                  {item[td.name]}
                </td>
              ),
            )
          )
        ) : null}
        {urldata === '/Order' && <td>{item?.isNeededWorker}</td>}
      </tr>
      {moreitem ? (
        <Row className='p-2' style={{ display: 'block' }}>
          {arryheder.slice(8, arryheder.length).map((HederHelmet, index) =>
            HederHelmet.name === 'workerOrderSchedules' ? (
              <Col lg='12' sm='12' xs='12'>
                <p>{HederHelmet.label}</p>

                {item['workerOrderSchedules'].map((item, index) => (
                  <p key={index}>{`${index + 1} - ${item.firstName} ${
                    item.lastName
                  } ${item.periodTime} ${item.isFavorite}`}</p>
                ))}
              </Col>
            ) : (
              <Col lg='12' sm='12' xs='12' className='d-flex'>
                <p>{HederHelmet.label}</p>
                <span className='m-1'>:</span>
                {location.pathname === '/WorkerOrderSchedule' ? (
                  typeof keyarry[index + 12] === 'boolean' ? (
                    <p>
                      {keyarry[index + 12] ? (
                        <i className='fa fa-check'></i>
                      ) : (
                        <i className='fa fa-times'></i>
                      )}
                    </p>
                  ) : (
                    <p onClick={() => handelCopy(keyarry[index + 12])}>
                      {' '}
                      {keyarry[index + 12]}
                    </p>
                  )
                ) : urldata === '/WorkerOrderSchedule' ? (
                  typeof keyarry[index + 12] === 'boolean' ? (
                    <p>
                      {keyarry[index + 12] ? (
                        <i className='fa fa-check'></i>
                      ) : (
                        <i className='fa fa-times'></i>
                      )}
                    </p>
                  ) : (
                    <p onClick={() => handelCopy(keyarry[index + 12])}>
                      {' '}
                      {keyarry[index + 12]}
                    </p>
                  )
                ) : typeof keyarry[index + 12] === 'boolean' ? (
                  <p>
                    {keyarry[index + 12] ? (
                      <i className='fa fa-check'></i>
                    ) : (
                      <i className='fa fa-times'></i>
                    )}
                  </p>
                ) : HederHelmet.name.search('Amount') > -1 ||
                  HederHelmet.name.search('amount') > -1 ? (
                  <p onClick={() => handelCopy(keyarry[index + 12])}>
                    {' '}
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 16,
                    }).format(parseFloat(keyarry[index + 12]))}{' '}
                    <small>ريال</small>
                  </p>
                ) : (
                  <p onClick={() => handelCopy(keyarry[index + 12])}>
                    {' '}
                    {keyarry[index + 12]}
                  </p>
                )}
                <hr />
              </Col>
            ),
          )}
        </Row>
      ) : null}

      {show ? (
        <ModalDelete
          hasDescription={urldata === '/WorkerOrderSchedule' ? true : false}
          showitem={show}
          handeldeleteModal={handeldelete}
          handleCloseMoudal={handleClose}
          urldata={urldata}
          id={item.id}
        />
      ) : null}
      {showModalOrderTracking ? (
        <ModalOrderTracking
          showitem={showModalOrderTracking}
          handleCloseMoudal={handelcloseOrderTracking}
          id={item.id}
        />
      ) : null}
      {/* //bymas */}
      {ShowEditB2BWorker ? (
        <ModalEditB2BWorker
          showitem={ShowEditB2BWorker}
          handleCloseMoudal={handelCloseEditB2BWorker}
          id={item.id}
          handeldeleteitem={handeldeleteitem}
          handleRefreshGridWorker={handleRefreshGridWorker}
        />
      ) : null}

      {ShowModalJobDispatchWorker ? (
        <ModalJobDispatchWorker
          showitem={ShowModalJobDispatchWorker}
          handleCloseMoudal={handelHideModalJobDispatchWorker}
          id={item.id}
          persianStartWork={item.persianStartWork}
          //handeldeleteitem={handeldeleteitem}
          // handleRefreshGridWorker={handleRefreshGridWorker}
        />
      ) : null}

      {Showcreateworker ? (
        <ModalCreateworker
          showitem={Showcreateworker}
          handleCloseMoudal={handelClosecreateworker}
          id={item.id}
          handeldeleteitem={handeldeleteitem}
          handleRefreshGridWorker={handleRefreshGridWorker}
        />
      ) : null}
      {showModalUpdateSurvey ? (
        <ModalUpdateSurvey
          businessType={item?.isKarlineCustomer ? 1 : 0}
          showitem={showModalUpdateSurvey}
          handleCloseMoudal={handleCloseModalUpdateSurvey}
          id={item?.id}
          handeldeleteitem={handeldeleteitem}
          isFromApp={item?.appType === 2}
          survey={item?.survey}
        />
      ) : null}
      {showModalCancel ? (
        <ModalCancel
          showitem={showModalCancel}
          handleCloseMoudal={handelCloseCancel}
          access={urldata ? urldata : location.pathname}
          id={item.id}
          handeldeleteitem={handeldeleteitem}
        />
      ) : null}
      {RollbackModal ? (
        <ModalRollback
          showitem={RollbackModal}
          handleCloseMoudal={handelCloseRollback}
          access={urldata ? urldata : location.pathname}
          id={item.id}
          // handelRollback={Rollback}
        />
      ) : null}
      {showConfrim ? (
        <ModalConfrim
          showitem={showConfrim}
          handleCloseMoudal={handelCloseConfirm}
          id={item.id}
          handeldeleteitem={handeldeleteitem}
        />
      ) : null}
      {showModalTracking ? (
        <ModalDebtTracking
          showitem={showModalTracking}
          handleCloseMoudal={closeDebtTracking}
          id={item.id}
        />
      ) : null}
      {showModalDetial ? (
        <ModalDetial
          showitem={showModalDetial}
          handelclosemodal={closeModalDetial}
          id={item.id}
          url={location.pathname === '/OnlineOrder' ? 'OnlineOrder' : null}
        />
      ) : null}
      {showOrderCommission ? (
        <ModalOrderCommisson
          sohwitem={showOrderCommission}
          handelClosemodal={closeMdalOrderCommission}
          id={item.id}
        />
      ) : null}

      {jobsituation ? (
        <ModalJobSituation
          sohwitem={jobsituation}
          handelClosemodal={handelCloseModaljobsituation}
          id={item.id}
          arryactions={arryactions}
          handeldeleteitem={handeldeleteitem}
        />
      ) : null}
      {customSms ? (
        <ModalCustomSms
          sohwitem={customSms}
          handelClosemodal={handelCloseModalCustomSms}
          id={item.id}
        />
      ) : null}
    </>
  );
}
